import React from "react";
import DepartmentRuntimePage from "./DepartmentRuntimePage";

export default function ParboiledProductionPage() {
  return (
    <DepartmentRuntimePage
      department="parboiled"
      eyebrow="Production · Parboiled"
      title="Parboiled Department"
      description="Steaming and dryer sections — each runs on its own stopwatch. More parboiled features can be added to this page later."
      testId="parboiled-production-page"
      sectionEyebrow="Parboiled section"
    />
  );
}
